import { Navigate, Outlet } from "react-router-dom";

import { useAuth } from "../hooks/useAuth";

const PublicOnlyRoute = () => {
  const { isAuthenticated, user } = useAuth();

  if (isAuthenticated && user) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
};

export default PublicOnlyRoute;
